<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0051_approval_history_device_embedded_information_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="機器・組込情報" >

            
          </title-and-slot>

          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4">
              <button class="btn btn-primary btn-xs" style="float: left;margin-left: 10px;" @click="backToList" >＜　戻る</button>
            </div>
            <div class="col-xs-8">
              <div v-if="is_new == false" style="width:180px;float:right;font-size:12px;text-align: right;">機器登録番号：{{deviceControlNumber}}</div>
              <div v-if="is_new == false" style="width:180px;float:right;font-size:12px;text-align: right;">登録日：{{registrationDate}}</div>
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;">
            状態：
            <input style=" border: solid #337ab7 1px;width: 60px; padding-left:4px;margin: 2px;border-radius: 5px;background-color: #e2ecf5;font-size: 12px;" value="使用中" />
             [承認] 申請No.：
          </div>
          <div class="row" style="margin-bottom:10px;">
            <div class="col-xs-4" style="">
              <!-- Coll A<br> -->
              <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly" :val="values[f.id]"></field-box>
            </div>
            <div class="col-xs-8" style="">
              <div class="row">
                <div class="col-xs-6" style="">
                  <!-- Coll B <br> -->
                  <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
                <div class="col-xs-6" style="">
                  <!-- Coll C<br> -->
                  <field-box   v-for="f in formFields.col3"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12" style="">
                  <field-box   v-for="f in formFields.col2b"  v-bind:key="f.id" v-bind:data="f" :read="readOnly"   :val="values[f.id]"></field-box>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-bottom:10px;" v-if="is_new == false">
            　<h3>組込情報</h3>
              <sub-table style="margin-bottom:20px"/>
          </div>
          <div>
              <button :disabled="false" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" >更新履歴</button>
              <button v-if="is_new == false" :disabled="false" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" @click="onConfirmExecuteProcess" >申請</button>
              <router-link
              to="/device_embedded_information_pegging2"
              type="button"
              class="btn btn-primary btn-xs"
              style="float: right;margin-left:10px;"
           　 >新規証書紐付</router-link>
              <button v-if="is_new == false" :disabled="false" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" >コピー</button>
              <button v-if="read_only == false" :disabled="false" class="btn btn-warning btn-xs" style="float: right;margin-left: 10px;" @click="onLocalSaveDevEmbedded" >登録</button>
              <button v-if="read_only == false" :disabled="false" class="btn btn-warning btn-xs" style="float: right;margin-left: 10px;" @click="btnCancel" >ｷｬﾝｾﾙ</button>
              <button v-else :disabled="false" class="btn btn-primary btn-xs" style="float: right;margin-left: 10px;" @click="onEdit" >編集</button>
          </div>

        </div>
        <device-embedded-information-confirmation-modal tag="showBulkImportConfimationModal" />
        <confirmation-modal tag="confirmDeviceEmbeddedInformationAddCheck" @done="onDeviceEmbeddedInformationAddCheckConfirm" />
    </div>
</template>

<script>
import deviceembeddedinformationaddcheck from '@/components/modals/device-embedded-information-add_check';
import subTable from '@/components/sub_pages/device-embedded-detail';
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_device_embedded_information';
import bulkImportConfirmationModal from "@/components/modals/device-embedded-information-confirmation-modal";
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:device_embedded_information');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';
export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    'sub-table': subTable,
    "device-embedded-information-confirmation-modal" :bulkImportConfirmationModal,
    'device-embedded-information-bach-edit-modal' : deviceembeddedinformationaddcheck
  },
  data() {
    return {
      api_name:"device_embedded_information",
      page_acl: acl.generic
    };
  },
  computed: {
    deviceControlNumber(){
      return this.$store.state.current_row["device_control_number"]
    },
    registrationDate(){
      return  utils.format_date(this.$store.state.current_row["registration_date"]);
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col1:[
          utils.extend(fields.device_control_number, {}),
          utils.extend(fields.computer_name, {}),
          utils.extend(fields.virtual_environment, {}),
          utils.extend(fields.virtual_base_unit, {}),
          utils.extend(fields.equipment_in_charge_department, {}),
          utils.extend(fields.equipment_in_charge_team, {}),
          utils.extend(fields.equipment_in_charge_classification, {}),
          utils.extend(fields.equipment_in_charge_system, {}),
          utils.extend(fields.approval_status, {}),
        ],
        col2:[
          utils.extend(fields.leasing_or_rental, {}),
          utils.extend(fields.manufacture_name, {}),
          utils.extend(fields.model_name, {}),
          utils.extend(fields.equipment_classification, {}),
          utils.extend(fields.cpu_count, {})
        ],
        col3:[
          utils.extend(fields.installation_team, {}),
          utils.extend(fields.installation_base, {}),
          utils.extend(fields.floor, {}),
          utils.extend(fields.user_name, {}),
          utils.extend(fields.installation_department, {})

        ],
        col2b:[
          utils.extend(fields.remarks, {})
        ],
      }
    }
  },
  methods: {
    onDeviceEmbeddedInformationAddCheckConfirm(mode){
      if(mode == "yes"){
        console.log("onDeviceEmbeddedInformationAddCheckConfirm",mode)
        this.read_only = false;
        this.commonSaveInfo(this,this.api_name, {} );
      }
    },
    onConfirmExecuteProcess(){
      bus.$emit("showBulkImportConfimationModal",{

      });
    },
    onLocalSaveDevEmbedded(){
      console.log("onLocalSave")
      bus.$emit("confirmDeviceEmbeddedInformationAddCheck",{
        message: "",
        title: "本当に登録してよろしいでしょうか。",
        yes_label: "完了",
        no_label: "キャンセル",
        yes_color:"primary",
        no_color:"",
        model_height:"50"
      });
    },
    onEdit(){
      mdebug("onEdit")
      setTimeout(() => {
        this.read_only = false;
      }, 300);
    },
    btnCancel() {
      this.cancelCurrentSelection(true);
    },
    backToList(){
      return this.$router.push({ name: "page_0010_device_embedded_information", params: {} });
    },
    gotocertificate(){
      return this.$router.push({ name: "page_0040_certificate_information", params: {} });
    },
    selectCertificate(){
      this.showSubTable = true;
    }
  },
  mounted() {
    if(this.$route.params.seq_id == "new"){
      this.local_seq_id = Number.MAX_SAFE_INTEGER;
      this.$store.state.current_row = {
        seq_id : this.local_seq_id
      }
      this.allFields.forEach(f =>{
        this.$store.state.current_row[f.id] = "";
      })
      setTimeout(() => {
        this.$store.state.is_editing_new = true;
        this.read_only = false;
        this.is_new = true;
      }, 300);
      mdebug("mounted as new")

    } else {
      this.is_new = false;
      this.local_seq_id = this.$route.params.seq_id;
      this.$ajax.post('/' + this.api_name + '/get/' + this.local_seq_id, {}, (err, result) => {
        if(err){
          this.$notify({
            title: 'データの読込に失敗しました。',
            text: err,
            type: 'error',
            duration: 10000
          });
        }
        this.$store.state.current_row = result.data;
        mdebug("LOAD DATA",{err, result});
      })
    }
  },
  beforeDestroy() {
  },
  beforeMount() {
  }
};

</script>
<style scoped>

.bottom_tab  {
  width: 100%;
  margin-bottom: 20px;
}
.bottom_tab th {
  font-size: 12px;
}
.bottom_tab td input{
  border: solid #337ab7 1px;
  width: 98%;
  margin: 2px;
  border-radius: 5px;
  background-color: #e2ecf5;
  font-size: 12px;
  padding-left:4px;
}
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>


// WEBPACK FOOTER //
// page_0051_approval_history_device_embedded_information_detail.vue?7d677a8b